import type { FetchArgs } from '@reduxjs/toolkit/query';

export function cloneFetchArgs(args: string | FetchArgs): string | FetchArgs {
  if (typeof args === 'string') return args;

  const { body, headers, params, ...rest } = args;

  const cloned: FetchArgs = { ...rest };

  if (headers instanceof Headers) {
    const h = new Headers();
    headers.forEach((v, k) => h.append(k, v));
    cloned.headers = h;
  } else if (headers && typeof headers === 'object') {
    cloned.headers = { ...(headers as Record<string, string>) };
  }

  if (params && typeof params === 'object') {
    cloned.params = { ...(params as Record<string, unknown>) };
  }

  if (!body) {
  } else if (body instanceof FormData) {
    const fd = new FormData();
    body.forEach((v, k) => fd.append(k, v as any));
    cloned.body = fd;
  } else if (body instanceof Blob) {
    cloned.body = body.slice(0, body.size, body.type);
  } else if (body instanceof ArrayBuffer) {
    cloned.body = body.slice(0);
  } else if (body instanceof URLSearchParams) {
    cloned.body = new URLSearchParams(body.toString());
  } else if (typeof body === 'string') {
    cloned.body = body;
  } else if (typeof body === 'object') {
    cloned.body = JSON.parse(JSON.stringify(body));
  } else {
    cloned.body = body as any;
  }

  return cloned;
}
